<template>
  <div>
    <b-modal
      id="modal-delete-file-digital-application"
      size="sm"
      centered
      ref="deleteFilesModal"
    >
      <template #modal-title>
        <div class="magenta-title">Löschen</div>
      </template>
      <div>
        <p class="mb-1">Möchten Sie das Dokument wirklich löschen?
        </p>
      </div>
      <template v-slot:modal-footer="{ close }">
        <b-button size="sm" variant="secondary" @click="close()">
          Nein
        </b-button>
        <b-button size="sm" variant="danger" @click="removeFile()">
          Ja
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    methods: {
      removeFile () {
        this.$refs.deleteFilesModal.hide()
        this.$root.$emit('removeFileFromCloudinary')
      },
      openModal () {
        this.$refs.deleteFilesModal.show()
      }
    }
  }
</script>

<style lang="scss">
#modal-help-digital-application {
  padding-left: 0 !important;

  .magenta-title {
    color: $magenta;
    font-weight: $font-weight-bold;
  }
}
</style>
